var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "multi-select form-control" }, [
    _c(
      "div",
      { staticClass: "list-wrapper" },
      _vm._l(_vm.list, function (x) {
        return _c(
          "div",
          {
            key: x.value,
            staticClass: "list-item",
            class: x.class,
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.toggleSelected(x)
              },
            },
          },
          [
            !x.isHeader && x.selected
              ? _c("i", { staticClass: "far fa-check-square" })
              : !x.isHeader && !x.selected
              ? _c("i", { staticClass: "far fa-square" })
              : x.isHeader && x.childrenSelected == "all"
              ? _c("i", { staticClass: "far fa-check-square" })
              : x.isHeader && x.childrenSelected == "none"
              ? _c("i", { staticClass: "far fa-square" })
              : x.isHeader && x.childrenSelected == "some"
              ? _c("i", { staticClass: "fa fa-square" })
              : _vm._e(),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(x.text))]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }